/* LUX 06.10.2026 (perf): start below-the-fold videos only when they are about to scroll into view.
   Markup contract: <video data-lux-src="..." [data-lux-type="video/mp4"] [data-lux-poster="..."] [data-lux-autoplay] preload="none" muted loop playsinline>.
   Nothing is downloaded (not even the poster) until the tile is within 300px of the viewport. */
(function () {
  if (window.__luxLazyVideo) return;
  window.__luxLazyVideo = true;

  function start(v) {
    if (v.__luxStarted) return;
    v.__luxStarted = true;
    var poster = v.getAttribute('data-lux-poster');
    if (poster && !v.getAttribute('poster')) v.setAttribute('poster', poster);
    var src = v.getAttribute('data-lux-src');
    if (src) {
      var s = document.createElement('source');
      s.src = src;
      s.type = v.getAttribute('data-lux-type') || 'video/mp4';
      v.appendChild(s);
    }
    v.preload = 'metadata';
    try { v.load(); } catch (e) {}
    if (v.hasAttribute('data-lux-autoplay')) {
      v.muted = true;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        start(e.target);
      });
    }, { rootMargin: '300px 0px' });
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('video[data-lux-src]');
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (v.__luxStarted || v.__luxWatching) continue;
      v.__luxWatching = true;
      if (io) io.observe(v); else start(v);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
